import styled from 'styled-components';
import { Heading, Text } from 'grommet';

const BORDER_COLOR = '#eee';

export const StyledHeader = styled.div`
  ${({ theme }) => theme.custom.helpers.LayoutContainer``};

  padding-top: 20px;
  padding-bottom: 20px;

  @media ${({ theme }) => theme.custom.layouts.above_large} {
    padding-top: 60px;
    padding-bottom: 40px;
  }

  > div {
    border-bottom: solid 1px ${BORDER_COLOR};
    padding-bottom: 10px;
    @media ${({ theme }) => theme.custom.layouts.above_large} {
      display: flex;
      align-items: baseline;
    }
  }
`;

export const StyledActiveType = styled(Heading)`
  /* @include title--xl; */
  /* font-family: $ff--serif; */
  padding-bottom: 20px;
  @media ${({ theme }) => theme.custom.layouts.above_large} {
    padding-bottom: 0px;
    padding-right: 20px;
  }
`;
export const StyledCount = styled(Text)``;
